import { BackButton } from '@applyonline/shared'
import type { JSX } from 'react'
import { useTranslation } from 'react-i18next'
import ConsentEn from './ConsentEn'
import ConsentFr from './ConsentFr'

const TermsAndConditionFlinksPage = (): JSX.Element => {
  const { i18n } = useTranslation()

  return (
    <main className="general-message">
      {i18n.language === 'fr' && <ConsentFr />}
      {i18n.language === 'en' && <ConsentEn />}
      <BackButton />
    </main>
  )
}

export default TermsAndConditionFlinksPage
